import { render } from "./EditChecklist.vue?vue&type=template&id=1b45f8ba"
import script from "./EditChecklist.vue?vue&type=script&lang=js"
export * from "./EditChecklist.vue?vue&type=script&lang=js"
script.render = render

export default script